var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.615 14.527a12.17 12.17 0 00-17.201 0L6 13.14a14.146 14.146 0 0120 0zm-2.827 2.827a8.193 8.193 0 00-11.547 0l-1.414-1.388a10.158 10.158 0 0114.366-.008l.008.008zm-2.801 2.8a4.23 4.23 0 00-5.945 0l-1.414-1.388a6.213 6.213 0 018.746 0zm-1.84 3.813a1.603 1.603 0 110-2.267 1.626 1.626 0 010 2.267z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--wireless-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'WirelessCircleIcon';
export default Icon;